import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useStore } from '../context/StoreContext';
import { safeNavigate } from '../utils/security';

const ANGLES = ['front','right','left','top','detail'];

export default function ProductCard({ product, onAddToCart }) {
  const [angleIdx, setAngleIdx] = useState(0);
  const [imgErrors, setImgErrors] = useState({});
  const { toggleWishlist, isInWishlist, addToCart } = useStore();
  const navigate = useNavigate();
  const inWishlist = isInWishlist(product.id);

  const imgs = ANGLES.map(k => product.images?.[k]).filter(Boolean);
  const frontSrc = imgs[0] || product.image || '';
  const hoverSrc = imgs[1] || frontSrc;

  const discount = product.originalPrice
    ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
    : 0;

  const handleImgError = (e) => {
    const fallback = imgs.find(src => src !== e.target.src);
    if (fallback) {
      e.target.src = fallback;
    } else {
      e.target.style.display = 'none';
    }
  };

  const handleWishlist = (e) => {
    e.preventDefault(); e.stopPropagation();
    toggleWishlist(product);
  };

  const handleCart = (e) => {
    e.preventDefault(); e.stopPropagation();
    if (onAddToCart) {
      onAddToCart(product);
    } else {
      addToCart({ ...product, variant: `${product.colors[0]} / ${product.sizes[0]}`, qty: 1 });
    }
  };

  const handleView = (e) => {
    e.preventDefault(); e.stopPropagation();
    safeNavigate(navigate, `/product/${product.id}`);
  };

  return (
    <div className="product-card">
      <div className="product-img-wrap">
        <img className="p-img-main" src={frontSrc} alt={product.name} loading="lazy" onError={handleImgError} />
        <img className="p-img-hover" src={hoverSrc} alt={`${product.name} alternate`} loading="lazy" onError={handleImgError} />

        {product.badge && <span className="product-badge">{product.badge}</span>}

        {/* Angle indicator dots */}
        {imgs.length > 1 && (
          <div className="angle-dots">
            {imgs.slice(0,5).map((_, i) => (
              <div key={i} className={`angle-dot ${i===angleIdx?'active':''}`} />
            ))}
          </div>
        )}

        {/* 3-button action bar */}
        <div className="product-actions">
          <button
            className={`p-action-btn p-action-wishlist ${inWishlist?'active':''}`}
            onClick={handleWishlist}
            aria-label={inWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
          >
            <i className={`${inWishlist?'fas':'far'} fa-heart`} />
            <span>{inWishlist ? 'Saved' : 'Wishlist'}</span>
          </button>
          <button className="p-action-btn p-action-cart" onClick={handleCart} aria-label="Add to cart">
            <i className="fas fa-bag-shopping" />
            <span>Add Cart</span>
          </button>
          <button className="p-action-btn p-action-view" onClick={handleView} aria-label="View details">
            <i className="fas fa-eye" />
            <span>View</span>
          </button>
        </div>
      </div>

      <Link to={`/product/${product.id}`} style={{ display: 'contents' }}>
        <div className="product-info">
          <span className="product-cat-tag">{product.subcategory || product.category}</span>
          <p className="product-name">{product.name}</p>
          <div className="product-stars">
            <span className="stars-gold">
              {[1,2,3,4,5].map(s => (
                <i key={s} className={`${s<=Math.round(product.rating)?'fas':'far'} fa-star`} style={{fontSize:'0.7rem'}} />
              ))}
            </span>
            <span className="review-ct">({product.reviews})</span>
          </div>
          <div className="product-price-row">
            <span className="product-price">₹{product.price.toLocaleString('en-IN')}</span>
            {product.originalPrice && <>
              <span className="product-price-orig">₹{product.originalPrice.toLocaleString('en-IN')}</span>
              {discount > 0 && <span className="product-discount">{discount}% off</span>}
            </>}
          </div>
        </div>
      </Link>
    </div>
  );
}
